import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

export const LanguageMaterialModules = [MatFormFieldModule, MatSelectModule];
